import {
    DEFAULT_CURRENCY,
    STATUS_TYPE,
    validityOptions,
} from '../../../utils/constants/commonValues';
import moment from 'moment';

function PaymentLinkList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

PaymentLinkList.prototype = Object.assign(PaymentLinkList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.linkDataList &&
            tableData.linkDataList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements, pageNo } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: pageNo || 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            amount,
            createdBy,
            createdOn,
            editedBy,
            editedOn,
            linkDataId,
            linkDataStatus,
            linkId,
            linkName,
            remarks,
            sharedCount,
            txnSuccessCount,
            validityPeriod,
            productInfo,
            maxAmount,
            templateInfo,
        } = row;
        return {
            amount,
            createdBy,
            editedBy,
            createdOn: this.convertDate(parseInt(createdOn, 10)),
            editedOn: this.convertDate(parseInt(editedOn, 10)),
            linkDataId: linkDataId || '-',
            linkDataStatus,
            linkId: linkId || '-',
            linkName: linkName || '-',
            remarks: remarks || '-',
            sharedCount: sharedCount || '-',
            txnSuccessCount: txnSuccessCount || '-',
            validityPeriod,
            maxAmount,
            amountView:
                amount || maxAmount
                    ? `${DEFAULT_CURRENCY} ${maxAmount ? maxAmount : amount}`
                    : '-',
            linkDataStatusView: this.getTransactionStatus(linkDataStatus),
            validityPeriodView: this.getValidity(validityPeriod),
            productInfo: productInfo.map((item, index) => {
                return {
                    ...item,
                    isMandatory: item.isMandatory ? ['isMandatory'] : [],
                };
            }),
            templateInfo,
        };
    },
    getTransactionStatus(status) {
        if (!status) {
            return '-';
        }
        return STATUS_TYPE[status];
    },
    getValidity(validityPeriod) {
        if (!validityPeriod) {
            return '-';
        }
        const values = validityOptions.filter(
            item => item.value === validityPeriod
        );
        return (values && values.length && values[0].name) || '-';
    },
    convertDate(date) {
        const dateString = moment(date).format('DD/MM/YYYY');
        return dateString;
    },
});

export default PaymentLinkList;
